import { useEffect, useState } from "react";
// import Box from '@mui/material/Box';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
// import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  UploadFile,
  DeleteFile,
  DownloadFile,
  GetVersionsByDeviceId,
  GetDeviceData,
} from "../Api";
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Input,
  InputLabel,
  MenuItem,
  Modal,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { DropzoneDialog } from "material-ui-dropzone";
import { Download } from "@mui/icons-material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { set } from "ace-builds-internal/config";
// import AddDeviceTypeModal from "./AddDeviceTypeModal";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
type Version = {
  version: string;
  uploadTime: string;
  description: string;
  deviceID: string;
  lastModified: string;
  size: number;
  tag: string;
};
export default function InteractiveList() {
  const { user } = useSelector((state: RootState) => state.user);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [files, setFiles] = useState<any>();
  const [versionName, setVersionName] = useState<string>("bugfix");
  const [description, setDescription] = useState<string>("");

  const [viewOpen, setViewOpen] = useState(false);
  const [filuploadLoading, setFiluploadLoading] = useState(false);
  const [uploadDilog, setUploadDilog] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState<any>();

  const [selectedDevice, setSelectedDevice] = useState<any>();
  const [allDevices, setAllDevices] = useState<any[]>([]);
  const [currentPageDevices, setCurrentPageDevices] = useState<any[]>();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState<string[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0); // 👈 for paginationTotalRows
  const [page, setPage] = useState<number>(1); // current page
  const [limit, setLimit] = useState<number>(10); // per-page limit
  const [open, setOpen] = useState<Record<string, boolean>>({});

  /** Detail cache: deviceID ➜ its object (or "loading") */
  const [details, setDetails] = useState<
    Record<string, any | "loading" | undefined>
  >({});
  // Helpers
  function paginate(data: any[], page: number, perPage: number) {
    const start = (page - 1) * perPage;
    return data.slice(start, start + perPage);
  }

  function performSearch(data: any[], query: string) {
    if (!query) return data;
    const lowered = query.toLowerCase();
    return data.filter((device) =>
      device.deviceID?.toLowerCase().includes(lowered)
    );
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (["Enter", " ", ","].includes(e.key)) {
      e.preventDefault();
      const newTag = tagInput.trim();
      if (newTag && !tags.includes(newTag)) {
        setTags([...tags, newTag]);
      }
      setTagInput("");
    }
  };

  const handleDelete = (tagToDelete: string) => {
    setTags(tags.filter((tag) => tag !== tagToDelete));
  };

  // Data Fetching
  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await GetDeviceData();
      const filtered = performSearch(data, searchQuery);
      setAllDevices(data);
      setTotalCount(filtered.length);
      setCurrentPageDevices(paginate(filtered, page, limit));
    } catch (error) {
      console.error("Failed to fetch devices:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const filtered = performSearch(allDevices, searchQuery);
    setTotalCount(filtered.length);
    setCurrentPageDevices(paginate(filtered, page, limit));
  }, [searchQuery, page, limit, allDevices]);

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    p: 4,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  // const handleDeviceTypeChange = (event: SelectChangeEvent<string>) => {
  //   setDeviceType(event.target.value as string);
  // };

  function upgradeVersion(currentVersion: string, level: string): string {
    // Split the current version name into major, minor, and patch parts
    const version = currentVersion.startsWith("v")
      ? currentVersion.slice(1)
      : currentVersion;

    const parts = version.split(".");
    if (parts.length !== 3) {
      throw new Error("Invalid version format. Expected format: x.y.z");
    }
    const [majorStr, patchStr, bugfixStr] = parts;
    const major = parseInt(majorStr, 10);
    const patch = parseInt(patchStr, 10);
    const bugfix = parseInt(bugfixStr, 10);

    if (level === "major") {
      return `v${major + 1}.0.0`;
    } else if (level === "minor") {
      return `v${major}.${patch + 1}.0`;
    } else if (level === "bugfix") {
      return `v${major}.${patch}.${bugfix + 1}`;
    } else {
      throw new Error("Invalid upgrade level");
    }
  }

  const submitFile = async (e: any) => {
    setFiluploadLoading(true);
    setFiles(e);
    if (selectedDevice?.deviceID === "" || versionName === "") {
      return <Alert severity="error">Please Fill all details</Alert>;
    }
    let upgradeVersionName = "v1.0.1";
    try {
      const result = await GetVersionsByDeviceId(selectedDevice?.deviceID);
       if (Array.isArray(result) && result.length > 0) {
        upgradeVersionName = upgradeVersion(result[0]?.version, versionName);
      } else if (!Array.isArray(result)) {
        <Alert severity="error">
          Something went wrong: inappropriate response.
        </Alert>;
        return;
      }
    } catch (error) {
      return (
        <Alert severity="error">Error while fetching available versions</Alert>
      );
    }
    // upgradeVersion(versionFiles[(versionFiles?.length)-1].version,versionName)
    // console.log("upgradeVersionName >> ", upgradeVersionName);
    // const res = await UploadFile(e, upgradeVersionName, description, deviceType);
    const res = await UploadFile(
      e,
      upgradeVersionName,
      description,
      selectedDevice?.deviceID,
      tags
    );

    if (res.code !== "ok") {
      return <Alert severity="error">Error on Submit file</Alert>;
    }

    setVersionName("bugfix");
    await fetchData();
    setOpen({});
    setDetails({});
    setUploadDilog(false);
    // setLoader(false);
    setOpenModal(false);
    setFiluploadLoading(false);
  };
  const handleToggle = async (id: string) => {
    const isCurrentlyOpen = open[id] ?? false;

    // Toggle the open state first
    setOpen((prev) => ({ ...prev, [id]: !isCurrentlyOpen }));

    // If collapsing (closing the toggle), clean up the details cache
    if (isCurrentlyOpen) {
      setDetails((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });
      return;
    }

    // If expanding (first-time open), fetch version details
    if (details[id] === undefined) {
      setDetails((prev) => ({ ...prev, [id]: "loading" }));

      try {
        const result = await GetVersionsByDeviceId(id);

        if (Array.isArray(result)) {
          setDetails((prev) => ({ ...prev, [id]: result }));
        } else {
          console.warn("Unexpected response:", result);
          setDetails((prev) => ({ ...prev, [id]: [] }));
        }
      } catch (error) {
        console.error("Error fetching versions:", error);
        setDetails((prev) => ({ ...prev, [id]: [] }));
      }
    }
  };

  function formatBytes(bytes: any, decimals = 1) {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
      "Bytes",
      "KiB",
      "MiB",
      "GiB",
      "TiB",
      "PiB",
      "EiB",
      "ZiB",
      "YiB",
    ];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (!user) return <>loading...</>;
  const isOpen = (id: string) => !!open[id];

  return (
    <>
      <Grid
        container
        spacing={1}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
        mt={4}
        columns={10}
      >
        <Grid xs={9}>
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <h3>List of Version Files</h3>
            <div>
              <Input
                type="text"
                placeholder="Search by Device ID or Tag"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setPage(1); // reset to first page on search
                }}
                style={{ width: "250px", marginRight: "16px" }}
              />

              <Button variant="contained" onClick={() => setOpenModal(true)}>
                Add Firmware
              </Button>
            </div>
            {/* </Grid> */}
          </Grid>

          <List>
            {currentPageDevices?.length === 0 ? (
              <>Empty</>
            ) : (
              currentPageDevices?.map((device, index: number) => (
                <React.Fragment key={index}>
                  <ListItem
                    button
                    onClick={() => handleToggle(device.deviceID)}
                  >
                    <ListItemText
                      primary={`Device ID: ${device.deviceID}`}
                      primaryTypographyProps={{ fontWeight: "bold" }}
                    />
                    {isOpen(device.deviceID) ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>

                  <Divider />
                  <Collapse
                    in={isOpen(device.deviceID)}
                    timeout="auto"
                    unmountOnExit
                  >
                    {/* Indent a little so it looks nested */}
                    <Box sx={{ pl: 4, py: 1 }}>
                      <Typography variant="body2">
                        {details[device.deviceID] === "loading" ? (
                          <Typography>Loading…</Typography>
                        ) : Array.isArray(details[device.deviceID]) &&
                          details[device.deviceID].length > 0 ? (
                          details[device.deviceID].map(
                            (data: any, i: number) => (
                              <React.Fragment key={i}>
                                <ListItem
                                  secondaryAction={
                                    <>
                                      <IconButton
                                        edge="end"
                                        aria-label="download"
                                      >
                                        <Download
                                          color="action"
                                          onClick={async () => {
                                            await DownloadFile(
                                              data?.version,
                                              data?.deviceID
                                            );
                                            await fetchData();
                                          }}
                                        />
                                      </IconButton>
                                      {user.role === "Admin" && (
                                        <IconButton
                                          style={{ marginLeft: "20px" }}
                                          edge="end"
                                          aria-label="delete"
                                        >
                                          <DeleteIcon
                                            color="error"
                                            onClick={async () => {
                                              await DeleteFile(
                                                data?.version,
                                                data?.deviceID
                                              );

                                              // 🧹 Reset cached details, so UI refetches when re-expanded
                                              setDetails({});
                                              setOpen({});
                                              // Refresh device list
                                              await fetchData();
                                            }}
                                          />
                                        </IconButton>
                                      )}
                                      <Button
                                        style={{ marginLeft: "40px" }}
                                        onClick={() => {
                                          setViewOpen(true);
                                          setSelectedVersion(data);
                                        }}
                                        size="small"
                                        variant="outlined"
                                      >
                                        View more
                                      </Button>
                                    </>
                                  }
                                >
                                  <ListItemAvatar>
                                    <Avatar>
                                      <FolderIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={
                                      data.tag
                                        ? `${data.version} | ${JSON.parse(
                                            data.tag
                                          ).join(" | ")}`
                                        : `${data.version}`
                                    }
                                    secondary={`Upload time : ${data?.uploadTime}`}
                                  />
                                </ListItem>
                                <Divider />
                              </React.Fragment>
                            )
                          )
                        ) : (
                          <Typography>No device versions available.</Typography>
                        )}
                      </Typography>
                    </Box>
                  </Collapse>
                </React.Fragment>
              ))
            )}
          </List>
        </Grid>
        <Pagination
          count={Math.ceil(totalCount / limit)}
          page={page}
          onChange={(e, val) => setPage(val)}
          color="primary"
        />
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <>
              <Typography sx={{ mt: 4, mb: 2 }} variant="h5" component="div">
                Upload New Version file
              </Typography>
              <Grid>
                <FormControl fullWidth style={{ marginBottom: "10px" }}>
                  <InputLabel id="device-id-label">Device ID</InputLabel>
                  <Select
                    labelId="device-id-label"
                    id="device-id"
                    value={!selectedDevice ? "" : selectedDevice.deviceID}
                    onChange={(e: SelectChangeEvent<string>) =>
                      setSelectedDevice(
                        allDevices?.length &&
                          allDevices?.find(
                            (data: any) => data?.deviceID === e.target.value
                          )
                      )
                    }
                    label="Device ID"
                  >
                    {!allDevices ? (
                      <MenuItem value={""}>{"Loading..."}</MenuItem>
                    ) : allDevices.length === 0 ? (
                      <MenuItem value={""}>{"No data available"}</MenuItem>
                    ) : (
                      allDevices &&
                      allDevices.length > 0 &&
                      allDevices?.map((data: any, i: any) => {
                        return (
                          <MenuItem value={data?.deviceID}>
                            {data?.deviceID}
                          </MenuItem>
                        );
                      })
                    )}
                    {/* <MenuItem value="ESP32">ESP32</MenuItem>
                    <MenuItem value="1">Device Type 1</MenuItem>
                    <MenuItem value="2">Device Type 2</MenuItem> */}
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Upgrade Type
                  </FormLabel>
                  <RadioGroup
                    row
                    defaultValue="bugfix"
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onChange={(e) => setVersionName(e.target.value)}
                  >
                    <FormControlLabel
                      value="bugfix"
                      control={<Radio />}
                      label="Bug fix"
                    />
                    <FormControlLabel
                      value="minor"
                      control={<Radio />}
                      label="Minor"
                    />
                    <FormControlLabel
                      value="major"
                      control={<Radio />}
                      label="Major"
                    />
                  </RadioGroup>
                </FormControl>
                {/* <FormControl fullWidth style={{ marginBottom: "10px" }}>
                  <InputLabel id="device-type-label">Device Type</InputLabel>
                  <Select
                    labelId="device-type-label"
                    id="device-type"
                    value={deviceType}
                    onChange={handleDeviceTypeChange}
                    label="Device Type"
                  >
                    <MenuItem value="ESP32">ESP32</MenuItem>
                    <MenuItem value="1">Device Type 1</MenuItem>
                    <MenuItem value="2">Device Type 2</MenuItem>
                  </Select>
                </FormControl> */}
                <TextField
                  fullWidth
                  style={{ marginBottom: "10px" }}
                  id="description"
                  label="Description"
                  variant="outlined"
                  multiline
                  minRows={5} // Adjust this value to increase/decrease the height
                  onChange={(e) => setDescription(e.target.value)}
                />
                <FormControl fullWidth style={{ marginBottom: "10px" }}>
                  <TextField
                    fullWidth
                    id="tag"
                    label="Add Tags"
                    variant="outlined"
                    value={tagInput}
                    onChange={(e) => setTagInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Type and press Enter, comma or space"
                  />
                  <Box
                    mt={1}
                    sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                  >
                    {tags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={tag}
                        onDelete={() => handleDelete(tag)}
                        color="primary"
                        variant="outlined"
                      />
                    ))}
                  </Box>
                </FormControl>
                {/* <FormControl fullWidth style={{ marginBottom: "10px" }}>
                  <TextField
                    fullWidth
                    id="tag"
                    label="Tag"
                    variant="outlined"
                    value={tag}
                    onChange={(e) => setTag(e.target.value)}
                  />
                </FormControl> */}
                <Button
                  // disabled={true}
                  disabled={selectedDevice ? false : true}
                  fullWidth={true}
                  variant="contained"
                  onClick={() => setUploadDilog(true)}
                >
                  Add File
                </Button>
                <DropzoneDialog
                  clearOnUnmount={true}
                  onSave={(e) => submitFile(e)}
                  showPreviews={true}
                  onClose={() => {
                    setUploadDilog(false);
                    setOpenModal(false);
                  }}
                  open={uploadDilog}
                  acceptedFiles={[".bin"]}
                />
              </Grid>
            </>
          </Box>
        </Modal>
        {/* {loader ? <CircularProgress /> : <></>} */}
        <Modal
          open={viewOpen}
          onClose={() => setViewOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              fontWeight={"bold"}
              variant="h5"
              component="h2"
              marginBottom={"40px"}
            >
              {`More about ${selectedVersion?.version} version`}
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              <ListItem sx={{ flex: "50%" }}>
                <ListItemText
                  primary="Version"
                  secondary={selectedVersion?.version}
                />
              </ListItem>
              <ListItem sx={{ flex: "50%" }}>
                <ListItemText
                  primary="Upload Time"
                  secondary={selectedVersion?.uploadTime}
                />
              </ListItem>
              {/* <ListItem sx={{ flex: "50%" }}>
                <ListItemText
                  primary="Device Type"
                  secondary={selectedVersion?.deviceType}
                />
              </ListItem> */}
              <ListItem sx={{ flex: "50%" }}>
                <ListItemText
                  primary="Device ID"
                  secondary={selectedVersion?.deviceID}
                />
              </ListItem>
              <ListItem sx={{ flex: "50%" }}>
                <ListItemText
                  primary="Description"
                  secondary={selectedVersion?.description}
                />
              </ListItem>
              <ListItem sx={{ flex: "50%" }}>
                <ListItemText
                  primary="Size"
                  secondary={formatBytes(selectedVersion?.size)}
                />
              </ListItem>
            </Box>
          </Box>
        </Modal>
        {/* <AddDeviceTypeModal deviceTypeModalOpen={deviceTypeModalOpen} setDeviceTypeModalOpen={setDeviceTypeModalOpen} /> */}
      </Grid>
    </>
  );
}
